(function($) {
    'use strict';

    var ToggleTable = function(el) {
        this.$el = $(el);
        this.init();
    };

    ToggleTable.prototype = {
        init: function() {
            this.foldToggles();
            this.bindEvents();
        },

        bindEvents: function() {
            var that = this;

            that.$el.find('.toggle-row .toggle').on('click', function() {
                var $toggleRow = $(this).closest('.toggle-row');

                if ($toggleRow.next().hasClass('toggle-row-description')) {
                    var $toggleRowDescription = $toggleRow.next();

                    that.toggleTableRow($toggleRow, $toggleRowDescription);
                }
            });
        },

        foldToggles: function() {
            // Toggle-Row folding
            this.$el.find('.toggle-row-description').toggleClass('untoggled');
            this.$el
                .find('.toggle-row .first-column > .icon')
                .toggleClass('icon-arrow-up icon-arrow-down');
        },

        toggleTableRow: function($toggleRow, $toggleRowDescription) {
            $toggleRow
                .find('.first-column > .icon')
                .toggleClass('icon-arrow-up icon-arrow-down');
            $toggleRowDescription.toggleClass('untoggled');
        }
    };

    $.fn.toggleTable = function(options) {
        var args = Array.prototype.slice.call(arguments, 1),
            $this,
            data;

        return this.each(function() {
            $this = $(this);
            data = $this.data('toggle-table');

            if (!data) {
                $this.data('toggle-table', (data = new ToggleTable(this, options)));
            }
            if (typeof options === 'string') {
                data[options](args);
            }
        });
    };

    $.fn.toggleTable.Constructor = ToggleTable;
})(jQuery);
